module.exports = __webpack_public_path__ + "static/media/collage.4c8113c4.png";